<template>
    <button @click="buy">Buy</button>
</template>
<script>
import {Api} from "@/api";

export default {
    methods: {
        async buy() {
            const redirectData = await Api.credit.buy({amount: 10});
            console.log(redirectData);
            debugger
            window.location = redirectData;
        }
    }
}
</script>
